import { render } from "./SiteInfo.vue?vue&type=template&id=660ab7d0"
import script from "./SiteInfo.vue?vue&type=script&lang=js"
export * from "./SiteInfo.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/pdmed-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__